import React from 'react';
import PropTypes from 'prop-types';
import './FeaturedProfilesCarousel.scss';
import divider from '../../../assets/images/rectangle.svg';
function FeaturedProfilesCarouselCard(_ref) {
  var image = _ref.image,
    title = _ref.title,
    text = _ref.text,
    source = _ref.source,
    link = _ref.link;
  return /*#__PURE__*/React.createElement("div", {
    className: "carousel-card"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    className: "d-block w-100 carousel-image",
    src: image,
    alt: title
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    className: "rectangle",
    src: divider,
    alt: ""
  }), /*#__PURE__*/React.createElement("p", {
    className: "carousel-text carousel-title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "carousel-text carousel-body"
  }, text), link ? /*#__PURE__*/React.createElement("a", {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary"
  }, source)) : /*#__PURE__*/React.createElement("p", {
    className: "carousel-text carousel-text-source"
  }, source)));
}
FeaturedProfilesCarouselCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  link: PropTypes.string
};
FeaturedProfilesCarouselCard.defaultProps = {
  link: null
};
export default FeaturedProfilesCarouselCard;